import Karmuh from './Karmuh';
import Constants from '../Shared/Constants';

const oidcScopes = ['openid', 'email', 'profile'].join(' ');

const Url = {
  addToSlack: (team) => {
    const karmuhOauths = `${(new Karmuh()).url()}/slack/oauths`;

    const params = team
      ? [
          `team=${team}`,
        ].join('&')
      : '';

    const paramString = params.length
      ? `?${params}`
      : ``;

    return `${karmuhOauths}${paramString}`;
  },
  slackConnectProfileSignIn: () => {
    const karmuhConnect = `${(new Karmuh()).url()}/slack/connect`;

    const params = [
      `response_type=code`,
      `scope=${encodeURIComponent(oidcScopes)}`,
      `client_id=${Constants.ClientId}`,
      `redirect_uri=${encodeURIComponent(karmuhConnect)}`,
    ].join('&');

    return `https://slack.com/openid/connect/authorize?${params}`;
  },
  slackSignIn: () => {
    const karmuhTokens = `${(new Karmuh()).url()}/slack/tokens`;

    const params = [
      `response_type=code`,
      `scope=${encodeURIComponent(oidcScopes)}`,
      `client_id=${Constants.ClientId}`,
      `redirect_uri=${encodeURIComponent(karmuhTokens)}`,
    ].join('&');

    return `https://slack.com/openid/connect/authorize?${params}`;
  },
  teamsSignIn: () => {
    return `${(new Karmuh()).url()}/teams/oauths?flow=signin`;
  },
  teamsConnectProfileSignIn: () => {
    return `${(new Karmuh()).url()}/teams/oauths?flow=connect`;
  },
  addToTeams: (team) => {
    const karmuhTeamsOauths = `${(new Karmuh()).url()}/teams/oauths`;

    const params = team
      ? [
          `tenant=${team}`,
        ].join('&')
      : '';

    const paramString = params.length
      ? `?${params}`
      : ``;

    return `${karmuhTeamsOauths}${paramString}`;
  },
};

export default Url;
